import React from 'react';
import TimeAgo from 'react-timeago';
import spinner from '../images/spinner.gif';
import {ellipses} from '../Helpers';
import '../App.css';

export default class SearchResults extends React.Component {

  constructor(props) {
    super(props);
    this.state = {results: [], isFetching: false};
  }

  getSearchResults(query) {
    query = query || this.props.query;
    if (this.state.isFetching) {
      return;
    }
    if (this.state.totalResults && this.state.results.length >= this.state.totalResults) {
      this.setState({isFetching: false});
      return;
    }
    let that = this;
    let page = this.state.page || 1;
    let url = window.location.protocol + '//' + window.location.host;
    this.setState({isFetching: true}, function() {
      console.log(` Request URL: ${url}/api/v1/search?q=${query}&page=${page}&type=${this.props.searchType}`);
      let searchUrl = `${url}/api/v1/search?q=${query}&page=${page}&per_page=50`;
      if (this.props.searchType)  {
        searchUrl = searchUrl + '&type=' + this.props.searchType;
      }
      fetch(searchUrl, function(err, data)  {
        if (data) {
          let parsedBody = JSON.parse(data.body);
          let results = that.state.results;
          if (parsedBody && parsedBody['results']) {
            results = results.concat(parsedBody['results']);
            let totalResults = parsedBody['meta']['total_count'];
            that.setState({totalResults: totalResults, results: results, page: (page + 1), isFetching: false});
            that.props.app.setState({searching: false});
          }
        } else {
          console.log('[SearchResults] Got error from search: err is: ' + err);
        }
      });
    });
  }

  isBottom(el) {
    if (el) {
      return el.getBoundingClientRect().bottom <= window.innerHeight;
    } else {
      return true;
    }
  }

  componentWillReceiveProps(newProps) {
    let that = this;
    if (!newProps.query || !newProps.searching) {
      return;
    }
    this.setState({results: [], totalResults: 0, page: 0}, function() {
      that.getSearchResults(newProps.query);
    });
  }

  componentDidMount() {
    document.addEventListener('scroll', this.trackScrolling);
    this.getSearchResults();
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.trackScrolling);
  }

  trackScrolling = () => {
    const wrappedElement = document.getElementById('searchDiv');
    if (this.isBottom(wrappedElement)) {
      this.getSearchResults();
      // Get more users..
      if ( this.state.results.length >= this.state.totalResults ) {
        document.removeEventListener('scroll', this.trackScrolling);
      }
    }
  };

  showProfile(e, user) {
    e.preventDefault();
    if (e.target.id !== 'chat') {
      this.props.app.showProfile(user);
    }
  }

  hideModal() {
    this.props.app.setState({showInviteModal: false});
  }

  addToConversation(e, username) {
    this.props.closeMe(e);
    this.props.app.addToConversation(e, username);
  }

  render() {
    window.scrollTo(0, 0);
    let spinnerObj = '';
    if (this.state.isFetching) {
      spinnerObj = <img className='spinner' src={spinner} alt='' />;
    }
    let totalResults = this.state.totalResults || '';
    let results = this.state.results;
    let resultElements = [];
    for (let i = 0; i < results.length; i++) {
      let rowClass = i % 2 ? 'row' : 'rowGrey';
      let element = '';
      if (results[i].type === 'post') {
        element = <div onClick={(e) => this.props.app.showPost(results[i])} key={results[i]._id['$oid']} className={rowClass} style={{padding: '8px', height: '35px'}}>
          {(results[i].image_url && results[i].image_url.indexOf('missing.png') === -1) ? <img className='avatarLeft' src={results[i].image_url} alt='' /> : ''}
          <div key={results[i]._id['$oid']} className='rowField' style={{width: '300px', padding: '6px'}}>
            {ellipses(results[i].title || results[i].text, 52)}
          </div>
          <div className='rowField' style={{fontSize: '11px', width: '80px', padding: '6px', textAlign: 'right'}}> <TimeAgo date={results[i].created_at} /></div>
          <div className='rowField' style={{textAlign: 'right', width: '80px', padding: '6px', }}>(score: {Math.round(Number(results[i].score) * 100) / 100})</div>
        </div>;
      } else if (results[i]['conversation_id']) {
        let conversations = this.props.app.state.conversations;
        let conversation = undefined;
        for (let c = 0; c < conversations.length; c++) {
          if (conversations[c]['_id']['$oid'] === results[i]['conversation_id']['$oid']) {
            conversation = conversations[c];
          }
        }
        element = <div onClick={(e) => this.props.app.showConversations(undefined, conversation)} key={results[i]._id['$oid']} className={rowClass} style={{padding: '8px', height: '35px'}}>
          {(results[i].image_url && results[i].image_url.indexOf('missing.png') === -1) ? <img className='avatarLeft' src={results[i].image_url} alt='' /> : ''}
          <div key={results[i]._id['$oid']} className='rowField' style={{width: '300px', padding: '6px'}}>
            {ellipses(results[i].body, 52)}
          </div>
          <div className='rowField' style={{fontSize: '11px', width: '80px', padding: '6px', textAlign: 'right'}}> <TimeAgo date={results[i].created_at} /></div>
          <div className='rowField' style={{textAlign: 'right', width: '80px', padding: '6px', }}>(score: {Math.round(Number(results[i].score) * 100) / 100})</div>
        </div>;
      } else {
        let messageButton = <button key={results[i].username} type='submit' id='chat' className='smallSubmitButton'
                                    onClick={(e) => {if (e.target.id === 'chat') { this.props.app.showConversations(results[i].username)}}}>Mensagem</button>
        element = <div onClick={(e) => this.showProfile(e, results[i])} key={results[i]._id['$oid']} className={rowClass} style={{padding: '8px', height: '35px'}}>
          <img className='avatarLeft' src={results[i].avatar} alt='' />
          <div key={results[i]._id['$oid']} className='rowField' style={{width: '220px', padding: '6px'}}>
            {results[i].username}
          </div>
          <div className='rowField' style={{fontSize: '11px', width: '80px', padding: '6px'}}>Joined <TimeAgo date={results[i].created_at} /></div>
          <div className='rowField' style={{textAlign: 'right', width: '80px', padding: '6px', }}>(score: {Math.round(Number(results[i].score) * 100) / 100})</div>
          {results[i].username !== this.props.user.username ? messageButton : ''}
        </div>;
      }
      resultElements.push(element);
    }
    let resultBottom = <div id='searchDiv' className='searchDiv'>
      {resultElements}
    </div>;
    let addStyle = {};
    return(
      <div className='timeline' style={addStyle}>
        <div className='postTitleText' style={{paddingLeft: '14px', paddingBottom: '8px'}}>
          Resultados ({totalResults})
          {spinnerObj}
        </div>
        {resultBottom}
      </div>
    );
  }
}
